export const RESET = 'USERDATAEMPLOYEE_LIST_RESET'
export const SET_ITEMS = 'USERDATAEMPLOYEE_LIST_SET_ITEMS'
export const SET_ERROR = 'USERDATAEMPLOYEE_LIST_SET_ERROR'
export const SET_VIEW = 'USERDATAEMPLOYEE_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'USERDATAEMPLOYEE_LIST_TOGGLE_LOADING'
